<h2 mat-dialog-title>
  <mat-icon class="title-icon">link</mat-icon>
  {{ 'WORKCLASSIFICATION.TEMPLATES.LINK.TITLE' | translate }}
</h2>
<mat-dialog-content class="dialog-container">
  <div class="app-container">
    @if (templatesLoading()) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    } @else if (loadFailed()) {
      <p>{{ 'WORKCLASSIFICATION.TEMPLATES.LOAD_FAILED' | translate }}</p>
    } @else if (templates().length === 0) {
      <p>{{ 'WORKCLASSIFICATION.TEMPLATES.APPLY.NO_TEMPLATES' | translate }}</p>
    } @else {
      <mat-form-field appearance="fill">
        <mat-label>{{ 'WORKCLASSIFICATION.TEMPLATES.APPLY.TEMPLATE' | translate }}</mat-label>
        <mat-icon matPrefix>account_tree</mat-icon>
        <mat-select [value]="selectedTemplateId()" (selectionChange)="selectTemplate($event.value)">
          @for (t of templates(); track t.id) {
            <mat-option [value]="t.id">
              {{ t.name }}@if (t.isDefault) { ({{ 'WORKCLASSIFICATION.TEMPLATES.DEFAULT_BADGE' | translate }}) }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <p class="info-note">
        <mat-icon class="info-icon">info</mat-icon>
        {{ 'WORKCLASSIFICATION.TEMPLATES.LINK.INFO' | translate }}
      </p>

      @if (previewLoading()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        <p class="text-faint">{{ 'WORKCLASSIFICATION.TEMPLATES.LINK.COMPARING' | translate }}</p>
      } @else if (preview(); as p) {
        @if (p.matches.length === 0) {
          <p>{{ 'WORKCLASSIFICATION.TEMPLATES.LINK.NO_MATCHES' | translate }}</p>
        } @else {
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'WORKCLASSIFICATION.TEMPLATES.LINK.MATCHES' | translate: { count: selectedCount(), total: p.matches.length } }}</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-checkbox [checked]="allSelected()" [indeterminate]="selectedCount() > 0 && !allSelected()" (change)="toggleAll($event.checked)">
              {{ 'WORKCLASSIFICATION.TEMPLATES.LINK.SELECT_ALL' | translate }}
            </mat-checkbox>
            <div class="check-list">
              @for (m of p.matches; track m.projectNodeId) {
                <mat-checkbox [checked]="isSelected(m.projectNodeId)" (change)="toggle(m.projectNodeId, $event.checked)">{{ m.path }}</mat-checkbox>
              }
            </div>
          </mat-expansion-panel>
        }

        @if (p.unmatchedProjectNodes.length > 0) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'WORKCLASSIFICATION.TEMPLATES.LINK.UNMATCHED_PROJECT' | translate: { count: p.unmatchedProjectNodes.length } }}</mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="path-list">
              @for (n of p.unmatchedProjectNodes; track n.id) {
                <li>{{ n.path }}</li>
              }
            </ul>
          </mat-expansion-panel>
        }

        @if (p.unmatchedTemplateNodes.length > 0) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'WORKCLASSIFICATION.TEMPLATES.LINK.UNMATCHED_TEMPLATE' | translate: { count: p.unmatchedTemplateNodes.length } }}</mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="path-list">
              @for (n of p.unmatchedTemplateNodes; track n.id) {
                <li>{{ n.path }}</li>
              }
            </ul>
          </mat-expansion-panel>
        }

        @if (p.ambiguousPaths.length > 0) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>{{ 'WORKCLASSIFICATION.TEMPLATES.LINK.AMBIGUOUS' | translate: { count: p.ambiguousPaths.length } }}</mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="path-list">
              @for (path of p.ambiguousPaths; track path) {
                <li>{{ path }}</li>
              }
            </ul>
          </mat-expansion-panel>
        }
      }
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button class="btn-secondary" mat-dialog-close>{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-raised-button class="btn-primary" (click)="link()" [disabled]="!canLink()">
    {{ 'WORKCLASSIFICATION.TEMPLATES.LINK.CONFIRM' | translate: { count: selectedCount() } }}
  </button>
</mat-dialog-actions>
